import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSearchInputValue } from "../../../redux/slice/sliceHome";

const SearchComponent = ({ setIsSearchOpen }) => {
  const { searchInputValue } = useSelector((state) => state.homeSlice);
  const [text, setText] = useState(searchInputValue);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = () => {
    dispatch(setSearchInputValue(text));
    setIsSearchOpen(false);
    navigate(`/search`);
  };

  return (
    <div>
      <div className="searchBoxpopup">
        <form onSubmit={handleSubmit}>
          <label htmlFor="search-input" className="visually-hidden">
            Label
          </label>
          <input
            id="search-input"
            type="text"
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Search..."
          />
          <button
            type="submit"
            className="search-reset"
            aria-label="Submit search"
          >
            <i className="fa fa-search" aria-hidden="true"></i>
          </button>
        </form>
      </div>
    </div>
  );
};

export default SearchComponent;
